import { createFileRoute } from '@tanstack/react-router';
import { InstructionQueue } from '../../features/money-boundary/components/InstructionQueue';
import { usePageTitle } from '../../lib/hooks.js';

export const Route = createFileRoute('/_auth/instructions')({
  component: InstructionsPage,
});

function InstructionsPage() {
  usePageTitle('Instructions');
  return <InstructionQueue />;
}
